'use client'
import { useEffect, useState } from "react";
import Cookies from 'js-cookie'
import { useRouter } from "next/navigation";
import Link from "next/link";
import Image from "next/image";
import logo from '@/assets/images/logo.png'
import check from '@/assets/images/approval-check.png';
import rejected from '@/assets/images/rejected.svg';
import { useQuery } from "@tanstack/react-query";
import CustomFetch from "@/Utils/APIRequest/AxiosInstance";
import { SelfAPI } from "@/Utils/APIRequest/Endpoints";
import Loader from "@/Layout/Loader";
import GradientBorderButton from "@/Component/Common/Forms/GradientBorderButton";

const ApprovalPending = () => {
    const router = useRouter()
    const [toggleNotification, setToggleNotification] = useState(false)
    // const { data: UserData, isPending } = useQuery({
    //     queryKey: [SelfAPI], queryFn: () => CustomFetch({ url: `${SelfAPI}` }, null, false), refetchOnWindowFocus: false, select: (data) => data?.data?.data
    // });
    // useEffect(() => {
    //     if (UserData?.join_status == "accepted") {
    //         let userInfoCookie = Cookies.get('user_info')
    //         userInfoCookie = JSON.parse(userInfoCookie)
    //         userInfoCookie['join_status'] = UserData?.join_status
    //         userInfoCookie = JSON.stringify(userInfoCookie)
    //         Cookies.set("user_info", userInfoCookie)
    //         router.push('/dashboard')
    //     }
    // }, [isPending, UserData])

    // if (isPending) return <Loader />
    return (
        <div className="h-screen overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray/10 [&::-webkit-scrollbar-thumb]:bg-gray/50 relative sm:px-8 px-5 sm:pt-12 pt-8">
            <div className="mx-auto max-w-6xl">
                <div className="flex items-center justify-between mb-5">
                    <Link href="/">
                        <Image src={logo} alt='Logo' className="max-sm:w-32 sm:h-10 w-auto" />
                    </Link>
                    <GradientBorderButton customClass='w-full max-w-40' buttonType='button' >
                        Contact Us
                        {/* {isPending && <LoaderSVG customClass='ml-2.5' />} */}
                    </GradientBorderButton>
                </div>
                <div className="flex items-center flex-col justify-center h-[calc(100vh-128px)] text-center">
                    {/* <Image src={UserData?.join_status == "rejected" ? rejected : check} height={128} width={141} alt="Approval Pending" /> */}
                    <Image src={check} height={128} width={141} alt="Approval Pending" />
                    <h1 className="sm:text-3xl text-2xl font-semibold mt-6 mb-2">Registration Completed</h1>
                    <p className="sm:text-xl text-gray font-medium max-w-xs">Thank you for your application! We will review it and get back to you soon. Stay tuned!</p>
                </div>
            </div>
        </div>
    )
}

export default ApprovalPending
